import './App.css';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import { useState } from 'react';
import Accueil from './pages/Accueil';
import Presentation from './pages/Presentation';
import Actualites from './pages/Actualites';
import Boutique from './pages/Boutique';
import Contact from './pages/Contact';
import Horaires from './pages/Horaires';
import Partenaires from './pages/Partenaires';
import EspaceBenevoles from './pages/Admin/EspaceBenevoles';
// import Compteur from './pages/Compteur';
import Avril from './pages/Horaires/Avril';
import Mai from './pages/Horaires/Mai';
import Juin from './pages/Horaires/Juin';
import Juillet from './pages/Horaires/Juillet';
import Aout from './pages/Horaires/Aout';
import Septembre from './pages/Horaires/Septembre';
import Octobre from './pages/Horaires/Octobre';
import Novembre from './pages/Horaires/Novembre';

import Navigation from './components/Navigation';

function App() {
  const [benevoleState, setBenevoleState] = useState({
    token: '',
    droit: '',
    currentView: 'planning' // 'planning', 'admin', 'gestion'
  });

  const handleLogout = () => {
    setBenevoleState({
      token: '',
      droit: '',
      currentView: 'planning'
    });
    localStorage.removeItem('token');
  };

  const handleViewChange = (view) => {
    setBenevoleState(prev => ({
      ...prev,
      currentView: view
    }));
  };

  const handleBenevoleStateChange = (newState) => {
    setBenevoleState(newState);
  };

  return (
    <div className="App" lang="fr">
        
        <BrowserRouter>
        <Navigation
          token={benevoleState.token}
          droit={benevoleState.droit}
          currentView={benevoleState.currentView}
          onLogout={handleLogout}
          onViewChange={handleViewChange}
        />
            <Routes>
                <Route path="/" element={<Accueil />} />
                <Route path="/Accueil" element={<Accueil />} />
                <Route path="/presentation" element={<Presentation />} />
                <Route path="/actualites" element={<Actualites />} />
                <Route path="/boutique" element={<Boutique />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/horaires" element={<Horaires />} />
                <Route path="/Partenaires" element={<Partenaires />} />
                <Route path="/EspaceBenevoles" element={
                  <EspaceBenevoles 
                    benevoleState={benevoleState}
                    onBenevoleStateChange={handleBenevoleStateChange}
                  />
                } />
                {/* <Route path="/planning" element={<Planning />} />
                <Route path="/connexion" element={<Connexion />} /> */}
                {/* <Route path="/compteur" element={<Compteur />} /> */}
                {/* <Route path="/ZoomActualites" element={<ZoomActualites />} />  */}
                <Route path="/Avril" element={<Avril />} />
                <Route path="/Mai" element={<Mai />} />
                <Route path="/Juin" element={<Juin />} />
                <Route path="/Juillet" element={<Juillet />} />
                <Route path="/Aout" element={<Aout />} />
                <Route path="/Septembre" element={<Septembre />} />
                <Route path="/Octobre" element={<Octobre />} />
                <Route path="/Novembre" element={<Novembre />} />
                <Route path="*" element={<Accueil />} />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;